/**
 * @desc 订舱提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinSelfReserveCabinRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfScattered/reserveCabin`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
